<template>
    <b-modal
        id="modal-preparationrecipe"
        size="xl"
        ref="modal"
        :title="this.formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
        @change="change"
    >
        <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
            {{ alertText }}
        </b-alert>
        <b-tabs card>
            <b-card>
                <b-tab :title="$t('com_basis', { ns: 'common' })" active>
                    <b-input-group
                        :prepend="$t('com_product', { ns: 'common' })"
                    >
                        <b-form-select
                            v-model="productieIngredientID"
                            :options="prodIngredientList"
                            @input="setProduct"
                            :disabled="isSelected"
                            :state="isSelected"
                        >
                            <template #first>
                                <b-form-select-option value=""
                                    >--
                                    {{
                                        $t('com_selecteer', {
                                            ns: 'common'
                                        })
                                    }}
                                    --</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-input-group>
                    <b-card-text>
                        <b-input-group
                            :prepend="$t('rep_omschrijving', { ns: 'report' })"
                            :label="$t('rep_omschrijving', { ns: 'report' })"
                        >
                            <b-form-textarea
                                v-model="localItem.omschrijving"
                                :placeholder="
                                    $t('rep_omschrijving', { ns: 'report' })
                                "
                                rows="3"
                                max-rows="6"
                                @change="setChanged"
                                :disabled="!allowEdit"
                                :state="
                                    localItem.omschrijving &&
                                    localItem.omschrijving.length > 4 &&
                                    localItem.omschrijving.length < 500
                                "
                            ></b-form-textarea>
                        </b-input-group>

                        <b-input-group
                            :prepend="$t('com_amount', { ns: 'common' })"
                            :label="$t('com_amount', { ns: 'common' })"
                        >
                            <b-form-input
                                :placeholder="
                                    $t('com_amount', { ns: 'common' })
                                "
                                type="number"
                                step="1"
                                v-model.number="localItem.hoeveelheid"
                                :state="
                                    localItem.hoeveelheid &&
                                    localItem.hoeveelheid > 0
                                "
                                :disabled="!allowEdit"
                                @change="setChangedAmount"
                            ></b-form-input>
                            <lookup-combo
                                v-model="localItem.eenheid"
                                v-bind:combotype="lctypeUnits"
                                v-bind:discrim="buProductString"
                                :doCheckState="true"
                                :disabled="!allowEdit"
                                @change="setChanged"
                            ></lookup-combo>
                        </b-input-group>
                        <b-input-group
                            :prepend="$t('com_temperatuur', { ns: 'common' })"
                            :label="$t('com_temperatuur', { ns: 'common' })"
                        >
                            <temperature-input
                                v-model.number="localItem.bewerkingsTemperatuur"
                                @change="setChanged"
                                :editAllowed="allowEdit"
                                :showFahrenheit="configUseFahrenheit"
                            />
                        </b-input-group>
                        <b-input-group
                            :prepend="$t('com_timespan', { ns: 'common' })"
                            :append="$t('com_minuten', { ns: 'common' })"
                            :label="$t('com_timespan', { ns: 'common' })"
                        >
                            <b-form-input
                                v-b-tooltip.hover
                                :title="
                                    $t('com_timedurationexplain', {
                                        ns: 'common'
                                    })
                                "
                                id="input-yield"
                                type="number"
                                step="0.1"
                                v-model.number="localItem.bewerkingsTijd"
                                :disabled="!allowEdit"
                                @change="setChanged"
                            ></b-form-input>
                        </b-input-group>
                        <b-input-group
                            :prepend="
                                $t('com_durationstorage', { ns: 'common' })
                            "
                            :append="$t('com_dagen', { ns: 'common' })"
                            :label="$t('com_durationstorage', { ns: 'common' })"
                        >
                            <b-form-input
                                v-b-tooltip.hover
                                :title="
                                    $t('com_durationstorageexplain', {
                                        ns: 'common'
                                    })
                                "
                                id="input-yield"
                                type="number"
                                step="0.1"
                                v-model.number="localItem.opslagduur"
                                :disabled="!allowEdit"
                                @change="setChanged"
                            ></b-form-input>
                        </b-input-group>
                    </b-card-text>
                    <b-form-textarea
                        v-model="localItem.opmerking"
                        :placeholder="$t('com_opmerking', { ns: 'common' })"
                        rows="3"
                        max-rows="6"
                        @change="setChanged"
                    ></b-form-textarea>
                </b-tab>
                <b-tab :title="$t('prod_ingredienten', { ns: 'production' })">
                    <b-card-text>
                        <b-row v-if="allowEdit">
                            <label for="lcingredient">
                                {{
                                    $t('prod_add', {
                                        ns: 'production',
                                        val: $t('prod_ingredient', {
                                            ns: 'production'
                                        }).toLowerCase()
                                    })
                                }}:</label
                            >
                            <div class="form-inline">
                                <ingredient-selector
                                    style="width: 60%"
                                    v-model="newIngredientID"
                                    @baseunit="buIngredient = $event"
                                    :includeWater="true"
                                />
                                <b-input-group
                                    style="width: 20%"
                                    :prepend="
                                        $t('com_amount', { ns: 'common' })
                                    "
                                    :label="$t('com_amount', { ns: 'common' })"
                                >
                                    <b-form-input
                                        id="input-hoeveelheid"
                                        :placeholder="
                                            $t('com_amount', { ns: 'common' })
                                        "
                                        type="number"
                                        step="1"
                                        v-model.number="amount"
                                    ></b-form-input>
                                </b-input-group>
                                <lookup-combo
                                    style="width: 15%"
                                    v-model="puIngredient"
                                    v-bind:combotype="lctypeUnits"
                                    v-bind:discrim="buIngredientString"
                                ></lookup-combo>

                                <b-button
                                    style="width: 5%"
                                    @click="addIngredient()"
                                    class="bgc_aux_normal"
                                    ><font-awesome-icon
                                        icon="arrow-down"
                                        size="1x"
                                    />
                                </b-button>
                            </div>
                        </b-row> </b-card-text
                ></b-tab> </b-card
        ></b-tabs>

        <b-table
            :items="displayList"
            :fields="visibleFields"
            stacked="md"
            show-empty
            :empty-text="$t('com_geen_data', { ns: 'common' })"
            small
            striped
        >
            <template v-slot:cell(actions)="row">
                <b-button
                    size="sm"
                    v-if="checkRight('RecipeClose')"
                    @click="verwijderItem(row.item)"
                    :disabled="!allowEdit"
                    class="bgc_aux_alarm"
                    ><font-awesome-icon icon="trash-alt" size="1x" />
                </b-button>
                <b-button
                    size="sm"
                    @click="toonDetails(row.item)"
                    class="bgc_aux_unknown"
                    ><font-awesome-icon icon="info-circle" size="1x" />
                </b-button>
            </template>
        </b-table>
        <h4>
            <b-badge :variant="variantColor" v-if="ingredientenHH > 0"
                >{{
                    $t('com_totaal', {
                        ns: 'common'
                    })
                }}
                = {{ ingredientenHH }}</b-badge
            >
        </h4>
    </b-modal>
</template>

<script>
import { loadItem, loadList } from '../../models/DataHelper';
import Helper from '../../models/Helper';
import { Permission } from '../../models/Permissions';
import { Feature } from '../../models/Features';
import { LookupCombo, TemperatureInput } from '../components';
import { IngredientElement, IngredientRecipe } from '../../models/Recept';
import { INGRCAT_ENUM } from '../../models/IngredientCategorie';
import IngredientSelector from '../recipe/IngredientSelector.vue';

export default {
    name: 'PreparationModal',
    data: function () {
        return {
            lctypeUnits: window.constants.LCPERUNITS,
            showDismissibleAlert: false,
            alertText: '',
            puIngredient: 0,
            buIngredient: 1,
            puProduct: 0,
            buProduct: 1,
            amount: 0,
            newIngredientID: 0,
            productieIngredientID: -1,
            ingredientteller: -1,
            ingredientenHH: 0,
            isChanged: false,
            isSelected: false,
            amountSeemsGood:true,
            displayList: [],
            prodIngredientList: []
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        inItem: {
            type: IngredientRecipe,
            default: null
        },
        visible: {
            type: Boolean,
            default: false
        },
        allowEdit: {
            type: Boolean,
            default: true
        }
    },
    components: {
        IngredientSelector,
        TemperatureInput,
        LookupCombo
    },
    watch: {},
    computed: {
        configUseFahrenheit() {
            const useF = this.checkFeature('conf_useFahrenheitinProduction');
            return useF;
        },
        buIngredientString() {
            const baseu = this.buIngredient;
            return baseu > -1 ? baseu.toString() : '';
        },
        buProductString() {
            const baseu = this.buProduct;
            return baseu > -1 ? baseu.toString() : '';
        },
        variantColor () {
            return this.amountSeemsGood ? 'light' : 'warning';
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                { key: 'id', label: 'Id', sortable: false, visible: false },
                {
                    key: 'naam',
                    label: this.$t('com_product', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'hoeveelheid',
                    label: this.$t('com_amount', { ns: 'common' }),
                    visible: true
                },
                {
                    key: 'eenheidNaam',
                    label: this.$t('com_unit', { ns: 'common' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        formtitle() {
            if (this.localItem == undefined) return '??';
            const nieuw =
                this.localItem.productID == undefined ||
                this.localItem.productID < 0;
            return Helper.stringformat(
                '{0} {1}: {2}',
                nieuw
                    ? this.$t('com_new', { ns: 'common' })
                    : this.$t('com_next', { ns: 'common' }),
                this.$t('com_recipe', { ns: 'common' }),
                this.localItem.naam ?? '??'
            );
        },
        localItem() {
            if (this.inItem == undefined) return null; // kan niet
            return this.inItem;
        }
    },
    methods: {
        setProduct() {
            this.isSelected = true;
            //this.localItem.productID = this.productieIngredientID;
            const product = this.prodIngredientList.find(
                (x) => x.value == this.productieIngredientID
            );
            this.buProduct = product.baseunit;
            this.localItem.naam = product.text;
        },
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        change(visible) {
            this.setChanged();
        },
        setChanged() {
            this.isChanged = true;
        },
        setChangedAmount() {
            this.setChanged();
            this.setTotaalIngredientenHH();
        },
        addIngredient() {
            const found = this.displayList.find(
                (x) => x.productID === this.newIngredientID
            );
            if (found) {
                const errormessage = this.$t('prod_ingredientinrecept', {
                    ns: 'production'
                });
                this.showAlert(errormessage);
            } else {
                const ingredient = this.$store.getters[
                    'components/getIngredientComboLijstbyID'
                ](this.newIngredientID);
                this.ingredientteller -= 1;
                const locRecIng = new IngredientElement({
                    id: this.ingredientteller
                });
                locRecIng.eenheid = this.puIngredient;
                const lijst =
                    this.$store.getters['components/getUnitsComboLijst'];
                const eenheid = lijst.find((x) => x.value == this.puIngredient);
                locRecIng.eenheidNaam = eenheid.naam;
                locRecIng.hoeveelheid = this.amount;
                locRecIng.product = this.newIngredientID;
                locRecIng.naam = ingredient
                    ? ingredient.naam
                    : this.$t('prod_water', { ns: 'production' });
                this.localItem.elementen.push(locRecIng);
                this.amount = 0;
                this.newIngredientID = -1;
                this.setTotaalIngredientenHH();
                this.setChanged();
            }
        },
        setTotaalIngredientenHH() {
            let totaalHH = 0;
            for (let i = 0; i < this.localItem.elementen.length; i++) {
                // tel kilos en liters gewoon bij elkaar op
                const ing = this.localItem.elementen[i];
                const unit = this.$store.getters['components/getUnitbyID'](
                    ing.eenheid
                );
                const ingHH = ing.hoeveelheid * (unit?.factor ?? 1);
                totaalHH += ingHH;
            }
            this.ingredientenHH = Helper.Round(totaalHH, 3);
            if (this.localItem.hoeveelheid) {
                const min = this.ingredientenHH * 0.9;
                const max = this.ingredientenHH * 1.1;
            this.amountSeemsGood = (this.localItem.hoeveelheid>min && this.localItem.hoeveelheid<max);
            }
        },
        async verwijderItem(item) {
            const doClose = await this.$root.showConfirmationBox(
                this.$t('com_delete', {
                    ns: 'common',
                    val: this.$t('com_product', { ns: 'common' })
                }) +
                    ' : ' +
                    item.naam
            );
            if (doClose) {
                for (let i = this.localItem.elementen.length - 1; i >= 0; i--) {
                    const id = this.localItem.elementen[i].product;
                    const test = item.product === id;
                    if (test) this.localItem.elementen.splice(i, 1);
                    this.setTotaalIngredientenHH();
                }
            }
        },
        checkFormValidity() {
            const invalidBasis = this.localItem.CheckValidity(this.$t);
            if (invalidBasis) {
                this.showAlert(invalidBasis);
                return false;
            }
            return true;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        async handleSubmit() {
            if (this.localItem.productID == undefined) {
                this.localItem.productID = this.productieIngredientID;
            }
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                return;
            }
            if (!(await this.awaitcheckTotaalIngredienten())) {
                return;
            }
            await this.saveThisRecept();
            this.$emit('changed');
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-preparationrecipe');
            });
        },
        async saveThisRecept() {
            this.localItem.isChanged = true;
            const saveRecipe = this.localItem.SetForSave();
            await loadItem(
                'preparation/saveProductionRecipe',
                saveRecipe,
                this.$t
            );
        },
        async awaitcheckTotaalIngredienten() {
            let totaalHH = 0;
            let doClose = true;
            for (let i = 0; i < this.localItem.elementen.length; i++) {
                // tel kilos en liters gewoon bij elkaar op
                const ing = this.localItem.elementen[i];
                const unit = this.$store.getters['components/getUnitbyID'](
                    ing.eenheid
                );
                const ingHH = ing.hoeveelheid * (unit?.factor ?? 1);
                totaalHH += ingHH;
            }
            this.ingredientenHH = Helper.Round(totaalHH, 3);
            if (this.localItem.hoeveelheid) {
                const min = this.ingredientenHH * 0.9;
                const max = this.ingredientenHH * 1.1;
                const amountSeemsGood =
                    this.localItem.hoeveelheid > min &&
                    this.localItem.hoeveelheid < max;
                if (!amountSeemsGood) {
                    // vraag bevestiging of afwijking klopt
                    doClose = await this.$root.showConfirmationBox(
                        Helper.stringformat(
                            this.$t('prod_hhmorethansum', {
                                ns: 'production'
                            }),
                            this.localItem.hoeveelheid,
                            this.ingredientenHH
                        )
                    );
                }
            }
            return doClose;
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        },
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        }
    },
    mounted() {},
    async created() {
        const templijst = await loadList(
            'components/getUnitsComboLijst',
            'components/loadUnitsComboLijst',
            null,
            false,
            this.$t
        );
        const cat = this.$store.getters['product/getIngredientCategorieByID'](
            INGRCAT_ENUM.Mix
        );
        const lijst = await loadList(
            'components/getIngredientComboLijst',
            'components/loadIngredientsForGroupComboLijst',
            null,
            true,
            this.$t
        );
        const filtered = lijst.filter((x) => x.category == cat.naam);
        this.prodIngredientList = filtered.map((x) => ({
            value: x.value,
            text: x.naam,
            baseunit: x.baseunit
        }));
        this.productieIngredientID = this.localItem.productID ?? -1;
        this.isSelected = this.productieIngredientID > 0;
        this.displayList = this.localItem.elementen;

        this.setTotaalIngredientenHH();
    }
};
</script>

<style scoped></style>
